import React from "react"

import {
  Dialog,
  Paper
} from "@mui/material"

import { styled } from "@mui/material/styles"

import "./HKVDialog.css"

const StyledPaper = styled(Paper, {
  shouldForwardProp: (prop) => prop !== "dialogSize",
})(({ theme, dialogSize }) => {
  const sizes = {
    xs: 440,
    sm: 660,
    md: 960,
    lg: 1260,
    xl: 1600,
    full: "100%"
  }
  const maxWidth = sizes[dialogSize] || 960

  return {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    maxWidth: maxWidth,
    margin: theme.spacing(4),
    [theme.breakpoints.down(maxWidth + 32)]: {
      margin: 0,
      maxHeight: "100%"
    },
    [theme.breakpoints.up(maxWidth + 32)]: {
      maxHeight: `calc(100% - ${theme.spacing(8)})`
    }
  }
})

const StyledDialog = styled(Dialog)({
  "& .MuiDialog-container": {
    flexDirection: "column"
  }
})

function HKVDialog({ config, noPaper, onClose, children }) {
  if (!config) return null

  return (
    <StyledDialog
      open={config.open}
      onClose={(event, reason) =>
        onClose && reason !== "backdropClick" ? onClose() : null
      }
      disableRestoreFocus
      maxWidth={false}
      slots={{
        paper: noPaper ? "div" : StyledPaper
      }}
      slotProps={{
        paper: { dialogSize: config.size }
      }}
    >
      {children}
    </StyledDialog>
  )
}

export default HKVDialog;
